module.exports = __webpack_public_path__ + "img/blue-cow.31cd761e.svg";